import { get } from '@webapp-next/lib/request/webapp/http';
import jwt from '@/lib/request/utils/jwt';

let COUNTRY_LIST_CACHE: Record<string, any> | null = null;

export async function getCountryList(): Promise<any> {
  if (COUNTRY_LIST_CACHE !== null) {
    return COUNTRY_LIST_CACHE;
  }

  const aud = 'DEPUTY';
  const claims = {
    deputy_user_id: '',
    deputy_business_id: '',
    deputy_employee_profile_id: '',
    deputy_business_user_id: '',
    deputy_business_location_id: '',
  };

  const token = await jwt({ aud, claims });

  const config = {
    headers: {
      Authorization: `OAuth ${token}`,
    },
  };

  const countryList = await get(
    `/api/v2/geo/countries?includes=states`,
    config
  );

  COUNTRY_LIST_CACHE = countryList.data;

  return countryList.data;
}
